export enum FrontEnum {
  LIMS = 'LIMS',
  PORTAL = 'PORTAL',
  CATALOGO = 'CATALOGO',
}
